import { render, staticRenderFns } from "./financialBreakdownWidget.vue?vue&type=template&id=5c2c15be&"
import script from "./financialBreakdownWidget.vue?vue&type=script&lang=js&"
export * from "./financialBreakdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports